<div class="main-container pt-9 pr-6">
  <!-- [ngClass]="{ 'loading-skeleton': (usersLoading$ | async) ?? false }" -->
  <section class="title-action-container loading-skeleton">
    <div class="company-name-container">
      <h1 for="" class="title">{{ currentCompany }} Users</h1>
      <label for=""
        >Last update <span>{{ lastUpdated }}</span></label
      >
    </div>
    <div class="action-container">
      <gbui-button
        [routerLink]="['/dashboard/users/add-users']"
        class="buttons-outline"
        >Add User</gbui-button
      >
    </div>
  </section>
  <section class="filter-container">
    <gbui-input
      simple
      (onChange)="filterChange($event)"
      placeholder="Search by name, user type, department or status"
    ></gbui-input>
  </section>
  <ng-template [ngIf]="usersFlag$ | async">
    <ng-container *ngIf="usersComplete.length > 0">
      <section class="table-container">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>User type</th>
              <!-- <th>Department</th> -->

              <th class="w-40px">Status</th>
              <th class="actions-cell"></th>
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="
                let user of users
                  | paginate
                    : {
                        itemsPerPage: itemsPerPages,
                        currentPage: currentPage,
                        id: 'usersTable',
                        totalItems: users.length
                      }
              "
            >
              <td>
                <span *ngIf="(user.firstName && user.firstName.trim()) || (user.lastName && user.lastName.trim()); else showEmail">
                  {{ user.firstName }} {{ user.lastName }}
                </span>
                <ng-template #showEmail>
                  <span class="user-email-wrap">{{ user.email }}</span>
                </ng-template>
              </td>
              <td>{{ userType(user.roles) }}</td>
              <!-- <td>
                {{ user.department || "Undefined" }}
              </td> -->
              <td class="w-40px">
                {{ user.isActive ? "Active" : "Inactive" }}
              </td>
              <td class="actions-cell">
                <div class="actions-wrapper">
                  <a
                    *ngIf="!user.isActive"
                    class="resend-invite-link"
                    [class.disabled]="isInviteLoading"
                    (click)="!isInviteLoading && resendInvite(user)"
                    >Resend Invite</a
                  >
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu"
                  >
                    <mat-icon>list</mat-icon>
                  </button>
                </div>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="userDetails(user)">
                    <span>Details</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <section class="paginator">
        <label for="">
          {{ currentPage * itemsPerPages - itemsPerPages + 1 }} -
          {{
            currentPage * itemsPerPages >= users.length
              ? users.length
              : currentPage * itemsPerPages
          }}
          of {{ this.usersCount$ | async }}</label
        >

        <pagination-controls
          id="usersTable"
          (pageChange)="pageChanged($event)"
          previousLabel=""
          nextLabel=""
        ></pagination-controls>
      </section>
    </ng-container>

    <ng-container *ngIf="usersComplete.length == 0">
      <label class="isEmpty"
        ><label class="isEmpty">There are no registered clients</label></label
      >
    </ng-container>
  </ng-template>
  <ng-template [ngIf]="usersLoading$ | async">
    <div class="custom-loader-container">
      <loader></loader>
    </div>
  </ng-template>
</div>
